import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { RaceCard } from "@/components/RaceCard";
import api from "@/lib/api";
import { Heart, Loader2, ArrowRight } from "lucide-react";

export default function MyRaces() {
  const [races, setRaces] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/saved").then(({ data }) => setRaces(data.races)).finally(() => setLoading(false)); };
  useEffect(load, []);

  return (
    <Layout>
      <div className="bg-[#0a1420] py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display font-black uppercase text-4xl text-white flex items-center gap-3"><Heart className="text-[#22d3ee]" /> My Races</h1>
          <p className="text-slate-300 mt-1">Your saved races, ready to plan and register.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {loading ? (
          <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-[#22d3ee]" size={32} /></div>
        ) : races.length === 0 ? (
          <div className="py-20 text-center">
            <Heart size={48} className="mx-auto text-slate-300" />
            <p className="font-display font-bold uppercase text-xl text-slate-700 mt-4">No saved races yet</p>
            <p className="text-slate-500 mt-2">Save races you're interested in to plan your season.</p>
            <Link to="/races" className="inline-flex items-center gap-2 mt-6 bg-[#0a1420] text-white font-bold px-6 py-3 rounded-lg hover:bg-[#22d3ee] hover:text-[#0a1420] transition-colors">Find Races <ArrowRight size={16} /></Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="my-races-grid">
            {races.map((r) => <RaceCard key={r.id} race={r} onSaveChange={(s) => !s && load()} />)}
          </div>
        )}
      </div>
    </Layout>
  );
}
